module.exports = __webpack_public_path__ + "static/media/adjust.2dc9f76b.svg";